<script lang="ts">
import { inject } from 'vue';

import { PhxsgButton as PhxsgCoreButton } from '@sg-core/src/View/Components/Atoms/Button';
import type { PhxsgButtonProps } from '@sg-core/src/View/Components/Atoms/Button';

import { PhxsgAccordionItemKey } from './phxsg-accordion-item.vue';
import { PhxsgAccordionKey } from './phxsg-accordion.vue';

import type { ComponentPublicInstance } from 'vue';

export interface PhxsgAccordionTriggerProps {
  icon?: PhxsgButtonProps['icon'];
}
</script>

<script setup lang="ts">
// Allow maisons to override the button component via provide/inject
const PhxsgButton = inject('PhxsgButton', PhxsgCoreButton);

const { icon } = defineProps<PhxsgAccordionTriggerProps>();

const accordionContext = inject(PhxsgAccordionKey);
const itemContext = inject(PhxsgAccordionItemKey);

if (!accordionContext || !itemContext) {
  throw new Error('PhxsgAccordionTrigger must be used inside a PhxsgAccordionItem');
}

const { boxed, isOpen, toggle } = accordionContext;
const { id, triggerRef } = itemContext;

function setTriggerRef(el: Element | ComponentPublicInstance | null): void {
  triggerRef.value = el ? ((el as ComponentPublicInstance).$el as HTMLElement) : null;
}
</script>

<template>
  <PhxsgButton
    :ref="setTriggerRef"
    class="phxsg-accordion__toggle"
    :icon="icon"
    :bare="boxed"
    :aria-expanded="isOpen(id) ? 'true' : 'false'"
    :aria-controls="`content-${id}`"
    @click="toggle(id)"
  >
    <slot />
  </PhxsgButton>
</template>
